module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-sm my-6\"> <div class=\"col-lg-8 col-md-6 mx-auto\"> <div class=\"card\" id=\"payment_methods\"> <div class=\"card-header\"> <h3 class=\"text-center\">Please select the preferred billing method for your account</h3> </div> <div class=\"card-body\"> ")
    ; (function(){
    ;  if(locals.isPrimary) { 
    ; __append("\n  <p class=\"bank_account_button\"></p>\n  <p class=\"credit_card_button\"></p>\n")
    ;  } else { 
    ; __append("\n  <div class=\"bank_account_button\"></div>\n  <div class=\"credit_card_button\"></div>\n  <p class=\"note\">\n    <strong>Add a Backup Card</strong><br>\n    This will fund your account in case the primary payment method fails to charge or has an outstanding transfer.</p>\n  <p class=\"note\">\n    <strong>Bank transfers take up to 5 business days to process</strong>, so it is recommended that bank account users register a backup card to ensure on-demand funding while transfers are processed.\n  </p>\n")
    ;  } 
    ; __append("\n")
    ; }).call(this)
    ; __append(" </div> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/checkout/billing/template.ejs
// module id = 1140
// module chunks = 1